// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"395":"4e2f4c88","471":"dad26ff7","924":"63d98096"}[chunkId] + ".chunk.css";
};